import { createAPI } from '@/request.js'
// 设备列表
export const list = data => createAPI('/api/equipment/query.mt', 'post', data)
// 绑定记录
export const bindList = data => createAPI('/api/equipment/binding/modify/log.mt', 'post', data)
// 设备回拨
export const recover = data => createAPI('/api/equipment/unbinding.mt', 'post', data)
// 设备
export const operate = data => createAPI('/api/equipment/room/operate.mt', 'post', data)
// 添加单个设备
export const add = data => createAPI('/api/equipment/insert.mt', 'post', data)
// 同步设备
export const check = data => createAPI('/api/equipment/check.mt', 'post', data)

// 下载设备列表
export const excelStatement = data => createAPI('/download/equipment/excel', 'get', data)

//
export const deviceLog = data => createAPI('/api/lock/query.mt', 'post', data)
